import qs from 'qs';
import { Page } from '@packages/common';
import { DynamicYieldPageType, DynamicYieldPageContext } from './dynamicYieldDataTypes';

export function getDYHomepageContext(): DynamicYieldPageContext {
  return { type: DynamicYieldPageType.HOMEPAGE };
}

export function getDYCategoryPageContext(categoryName: string): DynamicYieldPageContext {
  // make category name match the category-name in the dy-data-feed
  // first: trim all `/` from start and end, then replace all `/` with `|`
  const dyFeedCategoryName = categoryName.replace(/^\/+|\/+$/g, '').split('/');
  return { type: DynamicYieldPageType.CATEGORY, data: dyFeedCategoryName };
}

export function getDYOtherPageContext(): DynamicYieldPageContext {
  return { type: DynamicYieldPageType.OTHER };
}

export function getDYProductPageContext(urlParamsPart: string): DynamicYieldPageContext {
  const { quickview, quicklist } = qs.parse(urlParamsPart);
  const quickviewItemId = (quickview ?? quicklist) as string;
  return { type: DynamicYieldPageType.PRODUCT_PAGE, data: [quickviewItemId] };
}

export function getDynamicYieldPageContext(url: string, page: Page, categoryName?: string): DynamicYieldPageContext {
  const [baseUrl, params] = url.split('?');

  if (baseUrl === '/' && page === Page.home) {
    return getDYHomepageContext();
  }

  if (page === Page.category && /(quicklist)|(quickview)/.test(params)) {
    return getDYProductPageContext(params);
  }

  if (page === Page.category) {
    return getDYCategoryPageContext(categoryName ?? '');
  }

  return getDYOtherPageContext();
}

export function setDYPageContextObject(asPath: string, page: Page, categoryName?: string) {
  ((window as any).DY || {}).recommendationContext = getDynamicYieldPageContext(asPath, page, categoryName);
}

export function initDynamicYield(url: string, page: Page, categoryName?: string) {
  (window as any).DY = (window as any).DY || {};
  if ((window as any).DY && !(window as any).DY.recommendationContext) {
    (window as any).DY.recommendationContext = getDynamicYieldPageContext(url, page, categoryName);
  }
}
